import React from 'react';
import { Progress } from '@/designSystem/Progress';

interface SimilarityScoreProps {
  score: number;
  className?: string;
  compact?: boolean;
}

export const SimilarityScore: React.FC<SimilarityScoreProps> = ({
  score,
  className = "",
  compact = false,
}) => {
  return (
    <div className={`flex items-center gap-2 ${compact ? 'justify-between' : ''} ${className}`}>
      <div className="text-xs text-gray-500 whitespace-nowrap">
        Similarity Score:
      </div>

      <div className="flex-1">
        <Progress
          value={score}
          className="h-2 bg-gray-100"
          indicatorClassName="bg-green-500"
        />
      </div>

      <div className="text-xs font-medium text-gray-700 whitespace-nowrap">
        {score.toLocaleString(undefined, { maximumFractionDigits: 1 })}%
      </div>
    </div>
  );
};

export default SimilarityScore;